






















import { Component, Vue } from 'vue-property-decorator';
import {
  UserDTO,
} from '@/api';
import { usersModule, rolesModule } from '@/store';
import IconTimes from '@/assets/icons/times.svg';
import { Form } from 'element-ui';
import UserForm from './UserForm.vue';

interface IForm {
  firstName?: string;
  surname?: string;
  phoneNumber?: string;
  email?: string;
  roleIds?: Array<number>;
  password?: string;
}

@Component({
  name: 'users-edit-window',
  components: { UserForm, IconTimes },
})
export default class UsersEditWindow extends Vue {
  user: UserDTO & {password?: string} | null = null;

  visible = false;

  updateForm<K extends keyof UserDTO>(propertyName: K, value: UserDTO[K]) {
    if (this.user) {
      this.user[propertyName] = value;
    }
  }

  get rolesList() {
    return rolesModule.list;
  }

  open(user: UserDTO) {
    this.user = { ...user, password: '', roleIds: [...(user.roleIds || [])] };
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  blockUser() {
    // eslint-disable-next-line no-console
    console.log(this.user?.id);
  }

  async onSubmit() {
    // eslint-disable-next-line no-console
    console.log(this.user?.id);
    const form = ((this.$refs.form as UserForm).$refs.form as Form);

    let ready = false;
    form.validate((valid) => {
      ready = valid;
    });

    if (ready && this.user) {
      const user = {
        user: {
          firstName: this.user.firstName,
          surname: this.user.surname,
          phoneNumber: this.user.phoneNumber,
          email: this.user.email,
          description: this.user.description,
        },
        id: this.user.id,
        password: this.user.password ? this.user.password : undefined,
        roleIds: this.user.roleIds as unknown as number[],
      };
      await usersModule.saveUsers([user]);
      this.close();
    }
  }
}
